module.exports = __webpack_public_path__ + "static/EGO_x3-94d15850bfd4fc9afb9abf642d77d700.png";